import { css } from 'styled-components';

export const animationLength = 1000;

export const LoadingSpinMixin = css`
  animation: cssload-spin ${animationLength}ms infinite linear;

  @keyframes cssload-spin {
    100% {
      transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export const RefreshSpinMixin = css`
  animation: cssload-spin ${animationLength}ms infinite ease-in-out;

  @keyframes cssload-spin {
    100% {
      transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;
